// Który wers pokazać, mając odpowiedź serwera. Czysta logika, testowana.
//
// Serwer mówi, gdzie w tekście padło OSTATNIE rozpoznane słowo
// (`lineIndex`, `lineProgress`) i ile sekund przed końcem nagrania
// (`secondsAgo`). Do tego dochodzi czas podróży zapytania. Jeśli wers był już
// dośpiewany, a od jego ostatniego słowa minęło dość czasu, śpiewający jest
// najpewniej w następnym wersie, tylko Whisper nie zebrał jeszcze dwóch jego
// słów. Pomiar 25.09.2026 (synteza mowy, 26 okien): bez tej korekty 21
// trafień dokładnie w wers, z progiem 2,4 s 23 na 23 okna z odpowiedzią i
// zero wyprzedzeń; przy 1,2 s korekta wyprzedzała tekst pięć razy.

export interface OdpowiedzSerwera {
  /** Indeks w tablicy wersów wysłanych do serwera. */
  lineIndex: number;
  lineProgress?: number;
  secondsAgo?: number;
}

export const PROG_NASTEPNEGO_WERSU_S = 2.4;

export function wersDoPokazania(odp: OdpowiedzSerwera, podrozS: number, liczbaWersow: number): number {
  const dosp = (odp.lineProgress ?? 0) >= 0.9;
  const minelo = (odp.secondsAgo ?? 0) + podrozS;
  if (dosp && minelo >= PROG_NASTEPNEGO_WERSU_S && odp.lineIndex + 1 < liczbaWersow) return odp.lineIndex + 1;
  return odp.lineIndex;
}

/**
 * Czy przyjąć daleki skok, który serwer podał tylko jako kandydata (jego
 * strażnik skoku go odrzucił). Przyjmujemy, gdy poprzednie okno wskazało to
 * samo miejsce z dokładnością do wersu: jedno okno bywa pomyłką, dwa zgodne
 * pod rząd już nie. Bez tego śledzenie zgubione na powtarzanym refrenie nie
 * wracało wcale (PC MH, 25.09.2026, „Czarny blues o czwartej nad ranem”).
 */
export function potwierdzKandydata(poprzedni: number | null, obecny: number): boolean {
  return poprzedni !== null && Math.abs(poprzedni - obecny) <= 1;
}
